export type RegexControlConfig = {
  enabledGlobally: boolean; // true = regex ON, false = OFF
  disabledCategories?: string[]; // multiple categories allowed
  disabledBillers?: string[]; // multiple billerIds allowed
};

const norm = (s?: string) =>
  String(s ?? "")
    .trim()
    .toLowerCase();

export function isRegexEnabled(
  cfg: RegexControlConfig,
  ctx: { billerId?: string; categoryName?: string },
) {
  if (!cfg.enabledGlobally) return false;

  const billerId = norm(ctx.billerId);
  const category = norm(ctx.categoryName);

  if (cfg.disabledBillers?.some((x) => norm(x) === billerId)) return false;
  if (cfg.disabledCategories?.some((x) => norm(x) === category)) return false;

  return true;
}

// export function isRegexDisabled(
//   cfg: RegexControlConfig,
//   ctx: { billerId?: string; categoryName?: string }
// ) {
//   return !isRegexEnabled(cfg, ctx);
// }
